import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import CustomPagination from '../../CustomPagination';
import ReportManagementInformation from './ReportManagementInformation';
import Loader from '../../Loader/Loader';
import { withQuery } from '../../../hoc/withGraphql';
import ReportManagementQuery from './ReportManagement.graphql';
import messages from '../../../locale/messages';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './ReportManagement.css';

class ReportManagement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            currentPage: 1,
            searchList: '',
            typing: false,
            typingTimeout: 0,
            isRestrict: false,
        }
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode();
        this.setState({ isRestrict });
    }

    paginationData = (currentPage) => {
        const { reportUserManagement: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        refetch(variables);
    }
    handleClick = (searchList) => {
        const { reportUserManagement: { refetch } } = this.props;
        let variables = {
            currentPage: 1,
            searchList: searchList
        };
        this.setState({ currentPage: 1 });
        refetch(variables);
    }
    handleSearchChange = (e) => {
        const self = this;
        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }
        self.setState({
            searchList: e.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                self.handleClick(self.state.searchList);
            }, 450)
        });
    }


    render() {
        const { reportUserManagement: { reportUserManagement, loading } } = this.props;
        const { currentPage, isRestrict } = this.state;
        const { formatMessage } = this.props.intl;

        return (
            <div>
                {loading && <div><Loader type={"text"} /></div>}
                {!loading && <div>
                    <ReportManagementInformation reportUserManagement={reportUserManagement} formatMessage={formatMessage} handleSearch={(e) => this.handleSearchChange(e)} isRestrict={isRestrict} />
                    {
                        reportUserManagement && reportUserManagement.reportsData && reportUserManagement.reportsData.length > 0
                        && <div>
                            <CustomPagination
                                total={reportUserManagement.count}
                                currentPage={currentPage}
                                defaultCurrent={1}
                                defaultPageSize={10}
                                change={this.paginationData}
                                paginationLabel={formatMessage(messages.messagesLabel)}
                                isScroll
                            />
                        </div>
                    }
                </div>}
            </div>
        );
    }

}

const mapState = state => ({});

const mapDispatch = {
    demoRestrictionEncode
};

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch),
    withQuery(ReportManagementQuery, {
        name: 'reportUserManagement',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(ReportManagement);